'use client';

import * as Ably from 'ably';

let client: Ably.Realtime | null = null;
let currentOrgId: string | null = null;

export const getAblyClient = (orgId: string) => {
  if (client && currentOrgId === orgId) return client;

  // Org changed — close old connection, get new token with new project capabilities
  if (client) {
    client.close();
    client = null;
  }

  currentOrgId = orgId;
  client = new Ably.Realtime({
    authUrl: '/api/ably/token',
    authMethod: 'GET',
    autoConnect: typeof window !== 'undefined',
  });
  return client;
};
